import { useNavigate } from 'react-router';
import { Button, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { getShouldEnforcePermanentJobV2 } from '~/services/posthog/FeatureFlagUtils';
import { type CSSProperties } from 'react';
import PlusIcon from '~/images/icons/PlusIcon';

interface ICreatePostingButtonProps {
  text?: string;
  variant?: 'default' | 'lite';
  style?: CSSProperties;
  textStyle?: CSSProperties;
  dataCy?: string;
  onTrack?: (postingId?: string) => void;
}

const Styles = {
  Lite: {
    Button: {
      alignItems: 'center',
      backgroundColor: colors.secondary[500],
      borderRadius: 25,
      boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.15), 0 6px 10px 2px rgba(0, 0, 0, 0.15)',
      display: 'inline-flex',
      flexShrink: 0,
      gap: 4,
      height: 30,
      justifyContent: 'center',
      padding: '8px 12px',
    } as CSSProperties,
  },
};

export const CreatePostingButton: React.FC<ICreatePostingButtonProps> = ({
  text = 'Post a Job',
  variant = 'default',
  style,
  textStyle,
  dataCy = 'create-perm-job-button',
  onTrack,
}: ICreatePostingButtonProps) => {
  const navigate = useNavigate();

  const handleCreateDraft = () => {
    onTrack?.();
    navigate('/permanent-jobs/value-proposition');
  };

  if (!getShouldEnforcePermanentJobV2()) {
    return null;
  }

  if (variant === 'lite') {
    return (
      <button
        data-testid="create-permanent-job-button"
        data-cy={dataCy}
        style={Styles.Lite.Button}
        onClick={handleCreateDraft}
      >
        <PlusIcon color={colors.shades[0]} />
        <Typography as="span" bold color={colors.shades[0]} textAlign="center">
          {text}
        </Typography>
      </button>
    );
  }

  return (
    <Button
      data-testid="create-permanent-job-button"
      data-cy={dataCy}
      // width 206 has no DS size token; kept as inline style for the dashboard top-button row
      style={{ width: 206, ...style }}
      size="md"
      isLoading={false}
      onClick={handleCreateDraft}
    >
      <span style={textStyle}>{text}</span>
    </Button>
  );
};
